<template>
  <div class="user-preview">
    <ul id="result-list">
      <li>
        <section>
          <div class="company-area">
            <div
              class="clearfix"
              style="display: block;"
            >
              <h2
                class="company-name fwB"
                data-test="company-name"
              >
                {{ jobSearchResult.companyName }}
              </h2>
              <p
                data-test="posting-date"
                class="limit flr fs11"
              >
                掲載終了予定日&emsp;yy/mm/dd
              </p>
            </div>
            <h3 class="fs16 hd-type-02 company-title">
              <a
                data-test="job-title"
                class="job-title"
              >
                <span>{{ jobSearchResult.jobTitle }}</span>
              </a>
            </h3>

            <ul class="tags">
              <li>
                <ul class="icon">
                  <li class="new">
                    <img
                      data-test="new-icon"
                      :src="`${userOfferImageUrlForPc}/icon_company_new.png`"
                      alt="新着"
                    >
                  </li>
                  <li
                    v-if="jobSearchResult.isSimple && !jobSearchResult.isOriginalEntryForm"
                    data-test="simple"
                    class="simple"
                  >
                    <img
                      data-test="simple-icon"
                      :src="`${userOfferImageUrlForPc}/icon_company_simple.png`"
                      alt="シンプル"
                    >
                  </li>
                  <li class="company_interview">
                    <img
                      data-test="interview-icon"
                      :src="`${userCommonImageUrlForPc}/icon_company_interview.png`"
                      alt="インタビュー"
                    >
                  </li>
                  <li class="company_photo">
                    <img
                      data-test="photo-clip-icon"
                      :src="`${userCommonImageUrlForPc}/icon_company_photo.png`"
                      alt="フォトクリップ"
                    >
                  </li>
                </ul>
              </li>
              <li>
                <span class="fs18">｜</span>
              </li>
              <job-employment-status-pc :employment-status="employmentStatus" />
            </ul>
          </div>
          <article class="contents-inner">
            <div>
              <p
                data-test="main-title"
                class="fs15 fwB"
              >
                {{ jobSearchResult.mainTitle }}
              </p>
            </div>
            <figure class="premium-image">
              <img
                v-if="photoData && jobSearchResult.isExistsPremiumImage"
                :id="photoData.id"
                :src="getPhotoUrl(photoData)"
                class="premium-img"
                data-test="premium-photo"
              >
              <figcaption
                v-if="!jobSearchResult.isLightPlan && jobSearchResult.isExistsPremiumImage"
                data-test="premium-photo-caption"
                class="fs11 pt10 main-caption"
              >
                {{ jobSearchResult.mainCaption }}
              </figcaption>
            </figure>
            <div
              class="clearfix mt15"
              style="display: block;"
            >
              <div class="fll">
                <div class="details clearfix">
                  <div class="detail-left">
                    <h4>仕事内容</h4>
                  </div>
                  <div
                    data-test="job-content-outer"
                    :class="isLongContentStyle? 'detail-right -long': 'detail-right'"
                  >
                    <div
                      data-test="job-content-inner"
                      :class="isLongContentStyle? 'two-line' : 'three-line'"
                    >
                      <p>
                        {{ jobSearchResult.catchCopy }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="details clearfix">
                  <div class="detail-left">
                    <h4>応募資格</h4>
                  </div>
                  <div
                    data-test="offer-required-outer"
                    :class="isLongContentStyle? 'detail-right -long': 'detail-right'"
                  >
                    <div
                      data-test="offer-required-inner"
                      class="two-line"
                    >
                      <p>
                        {{ jobSearchResult.requiredSkill }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="details clearfix">
                  <div class="detail-left">
                    <h4>給与</h4>
                  </div>
                  <div
                    data-test="salary-outer"
                    :class="isLongContentStyle? 'detail-right -long': 'detail-right'"
                  >
                    <div
                      data-test="salary-inner"
                      class="two-line"
                    >
                      <p>
                        {{ jobSearchResult.salary }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="details clearfix">
                  <div class="detail-left">
                    <h4>勤務地</h4>
                  </div>
                  <div
                    data-test="place-outer"
                    :class="isLongContentStyle? 'detail-right -long': 'detail-right'"
                  >
                    <div
                      data-test="place-inner"
                      class="two-line"
                    >
                      <p>
                        {{ jobSearchResult.place }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <figure
                v-if="(photoData && !jobSearchResult.isLightPlan &&!jobSearchResult.isExistsPremiumImage)"
                class="flr"
              >
                <img
                  :id="photoData.id"
                  :src="getPhotoUrl(photoData)"
                  class="offer-img-main"
                  data-test="offer-main-image"
                >
                <figcaption
                  class="fs11 pt10 pega-pre-wrap"
                  data-test="offer-main-image-caption"
                  v-text="jobSearchResult.mainCaption"
                />
              </figure>
            </div>

            <div
              class="clearfix mt20"
              style="display: block;"
            >
              <job-appeal-point-pc
                :is-search-result="true"
                :pr-codes="prCodes"
              />
              <!--/* Lプラン以外 取材レポート start */-->
              <div
                v-if="!jobSearchResult.isLightPlan && report.body"
                class="viewpoints"
              >
                <img
                  class="mb5"
                  :src="`${userCommonImageUrlForPc}/viewpoints.png`"
                  alt="viewpoints"
                >
                <h3 class="fs12 fwB mt10">
                  女の転職！取材レポート
                </h3>
                <div class="fs12 plr10 tl short-viewpoint">
                  <p>
                    <span
                      v-if="report.name"
                      class="fwB"
                      data-test="reporter-name"
                      v-text="`取材担当${report.name}より／`"
                    />
                    <span
                      data-test="report"
                      v-text="report.body"
                    />
                  </p>
                </div>
              </div>
              <!--/* Lプラン以外 取材レポート end */-->
            </div>
          </article>

          <div class="col-type-02 pt25 pb25 btn-set">
            <a class="save-button review -mini fwB mr5 fade">
              <span class="fs14">
                <img
                  class="heart"
                  :src="`${userCommonImageUrlForPc}/icon_heart.png`"
                >気になる
              </span>
            </a>
            <a class="main-color-button -mini fwB ml10 fade">
              <span class="fs14">詳細を見る</span>
            </a>
          </div>
        </section>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/search/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobAppealPointPc from '@/components/molecules/JobAppealPointPc'
import JobEmploymentStatusPc from '@/components/molecules/JobEmploymentStatusPc'

export default {
  components: {
    JobAppealPointPc,
    JobEmploymentStatusPc
  },
  mixins: [jobPreviewCommon],
  props: {
    jobSearchResult: {
      type: Object,
      required: true
    },
    photoData: {
      type: Object,
      default: null
    },
    employmentStatus: {
      type: Array,
      default: () => []
    },
    prCodes: {
      type: Array,
      default: () => []
    },
    report: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isLongContentStyle () {
      return this.jobSearchResult.isExistsPremiumImage || this.jobSearchResult.isLightPlan
    }
  }
}
</script>
